var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('h1',{staticClass:"display-4"},[_vm._v("Benvenuto in eMet")]),(!_vm.loggedIn)?_c('div',[_vm._v(" Per accedere fai "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }